/**
 * AnnouncementPriorityService
 * Service for managing announcement priorities
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for announcement priority CRUD operations
 */
export class AnnouncementPriorityService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementPriorityService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementPriorityService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AnnouncementPriorityService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementPriorityService.BASE_PATH = 'api/announcement-priorities';
//# sourceMappingURL=AnnouncementPriorityService.js.map